import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { getToolName } from '../../data/toolLandingPages';

// Tools with a landing page render as a real <a href> so Google can crawl
// /rent/<slug>; the rest open the in-page bottom sheet.
export default function ToolCard({ tool, language, t, onSelect, landingSlug }) {
  const { lp } = useLanguage();
  const name = getToolName(tool, language);
  const available = tool.available && !tool.maintenance;
  const price = tool.pricePerDay; // 4h fallback temporarily hidden
  const priceLabel = t('rentPage.perDay');

  const body = (
    <>
      {tool.image ? (
        <img
          src={tool.image}
          alt={name}
          width="128"
          height="128"
          className="w-28 h-28 xl:w-32 xl:h-32 object-contain mb-2"
          loading="lazy"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      ) : (
        <div className="w-28 h-28 xl:w-32 xl:h-32 bg-gray-200 rounded-xl mb-2 flex items-center justify-center text-3xl" aria-hidden="true">🔧</div>
      )}
      <h3 className="text-[13px] font-semibold text-black leading-tight mb-1 flex-1">{name}</h3>
      <div className="mt-auto">
        {price > 0 && (
          <p className="text-[12px] text-dewalt font-bold mb-1 m-0">
            {t('rentPage.fromPrice')} {price} {priceLabel}
          </p>
        )}
        <span className={`text-[11px] px-2 py-0.5 rounded-full font-medium ${available ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-500'}`}>
          {available ? t('rentPage.available') : t('rentPage.unavailable')}
        </span>
      </div>
    </>
  );

  const className = 'bg-gray-50 rounded-2xl p-3 flex flex-col items-center text-center cursor-pointer active:scale-95 transition-transform no-underline';

  if (landingSlug) {
    return (
      <Link
        to={lp(`/rent/${landingSlug}`)}
        state={{ fromApp: true }}
        className={className}
      >
        {body}
      </Link>
    );
  }

  return (
    <article
      className={className}
      onClick={() => onSelect(tool)}
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onSelect(tool)}
    >
      {body}
    </article>
  );
}
